import { useSubscribeUpdateLeaveTypeIsPaidResult, useUpdateAbsentApprovalRequiredResult, useUpdateChildSickApprovalRequiredResult, useUpdateEmployeeWorkDayHoursResult, useUpdateHolidayAllowanceResult, useUpdateHolidayApprovalRequiredResult, useUpdateLeaveRangeResult, useUpdateSickApprovalRequiredResult, useUpdateSubTypeIsRequiredResult, useUpdateSubTypeIsRestrictedResult, } from '@famly/stat_absence-management-settings_data';
import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
import { useStatQuery } from '@famly/stat_use-stat-query';
import { useSubscribableUpdateStaffingSettingsMutationResult } from './use-update-staffing-settings-mutation';
import { useSubscribableUpdateAllowStaffAbsencesOnWeekendMutationResult } from './use-update-allow-staff-absences-on-weekend-mutation';
import { FetchStaffingSettings } from './fetch-staffing-settings.query';
export function useFetchStaffingSettings(options) {
    const queryResult = useStatQuery(FetchStaffingSettings, options);
    useSubscribableUpdateStaffingSettingsMutationResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings = result.staffhours.settings.updateAll;
                return cached;
            });
        }
    });
    useSubscribableUpdateAllowStaffAbsencesOnWeekendMutationResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.allowStaffAbsencesOnWeekend =
                    result.staffhours.settings.updateAllowStaffAbsencesOnWeekend;
                return cached;
            });
        }
    });
    useUpdateHolidayAllowanceResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.holidayAllowance = result.staffhours.settings.updateHolidayAllowance;
                return cached;
            });
        }
    });
    useUpdateLeaveRangeResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.holidayLeaveRangeV2 = result.staffhours.settings.updateHolidayLeaveRangeV2;
                return cached;
            });
        }
    });
    useUpdateEmployeeWorkDayHoursResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                const hoursValue = result.staffhours.settings.updateEmployeeWorkDay;
                cached.staffhours.settings.employeeWorkDay = hoursValue;
                // The adapter reads employeeWorkDayMin (in minutes), so convert hours to minutes
                cached.staffhours.settings.employeeWorkDayMin = hoursValue * 60;
                return cached;
            });
        }
    });
    useUpdateSubTypeIsRequiredResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.subTypeIsRequired = result.staffhours.settings.updateSubTypeIsRequired;
                return cached;
            });
        }
    });
    useUpdateSubTypeIsRestrictedResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.subTypeIsRestricted = result.staffhours.settings.updateSubTypeIsRestricted;
                return cached;
            });
        }
    });
    useUpdateHolidayApprovalRequiredResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.holidayApprovalRequired =
                    result.staffhours.settings.updateHolidayApprovalRequired;
                return cached;
            });
        }
    });
    useUpdateAbsentApprovalRequiredResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.absentApprovalRequired =
                    result.staffhours.settings.updateAbsentApprovalRequired;
                return cached;
            });
        }
    });
    useUpdateSickApprovalRequiredResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.sickApprovalRequired = result.staffhours.settings.updateSickApprovalRequired;
                return cached;
            });
        }
    });
    useUpdateChildSickApprovalRequiredResult(result => {
        if (result) {
            queryResult.updateQuery(cached => {
                cached.staffhours.settings.childSickApprovalRequired =
                    result.staffhours.settings.updateChildSickApprovalRequired;
                return cached;
            });
        }
    });
    useSubscribeUpdateLeaveTypeIsPaidResult((result, mutationOptions) => {
        if (result && (mutationOptions === null || mutationOptions === void 0 ? void 0 : mutationOptions.variables)) {
            const { leaveType, isPaid } = mutationOptions.variables;
            queryResult.updateQuery(cached => {
                switch (leaveType) {
                    case 'VACATION':
                        cached.staffhours.settings.holidayIsPaid = isPaid;
                        break;
                    case 'ABSENT':
                        cached.staffhours.settings.absentIsPaid = isPaid;
                        break;
                    case 'SICK':
                        cached.staffhours.settings.sickIsPaid = isPaid;
                        break;
                    case 'CHILD_SICK':
                        cached.staffhours.settings.childSickIsPaid = isPaid;
                        break;
                    default:
                        exhaustiveCheck(leaveType);
                }
                return cached;
            });
        }
    });
    return queryResult;
}
